import "./edit-employee-favorite.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormEmployeeFavorite from "../form-employee-favorite/form-employee-favorite";
import { useEditEmployeeFavorite } from "./edit-employee-favorite.hook";

export function EditEmployeeFavorite() {
  const {
    employeeFavoriteData,
    isLoading,
    employeeFavoriteError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditEmployeeFavorite();

  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
        <FormEmployeeFavorite />
      </section>
    </div>
  );

  return (
    <div id="EmployeeFavorite" className="employee-favorite">
      <HeaderContent
        title={"Edit Employee Group"}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {employeeFavoriteError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditEmployeeFavorite;
